import styled from 'styled-components';
import palette from '../../../lib/styles/palette';
import { useRef, useState, useEffect, useCallback } from 'react';

import { MdExpandMore, MdExpandLess, MdRemoveCircleOutline, MdAdd } from 'react-icons/md';
// import ActionButtons from '../ActionButtons';
// import AskCancelModal from '../AskCancelModal';

import { standardWeight_Trestle } from '../../../lib/data/standard-weight';

const TrestleForm = ({ onSaveStructure, onChangeWeightSummary, trestles, beltWidth }) => {
    const [isShow, setIsShow] = useState(trestles?.length || false);
    const [newTrestle, setNewTrestle] = useState(trestles || []);
    const [factor, setFactor] = useState('1.0');
    const [id, setId] = useState('');
    const [heightCategory, setHeightCategory] = useState('');
    const [height, setHeight] = useState('');
    const [standardWeight, setStandardWeight] = useState('');
    const [columnHeadWeight, setColumnHeadWeight] = useState('');
    const [qty, setQty] = useState('');
    const [unitWeight, setUnitWeight] = useState('');
    const [weight, setWeight] = useState('');
    const [totalQty, setTotalQty] = useState('');
    const [totalWeight, setTotalWeight] = useState('');
    // const [modal, setModal] = useState(false);
    /* 변경사항을 저장했었는지 여부에 대한 상태 저장 */
    const [isChanged, setIsChanged] = useState(false);

    /* standard weight library에서 해당 벨트폭을 뽑아서 저장한다. */
    const weightLibrary = useRef(null);

    /* category 설명하는 text */
    const categoryText = useRef({
        0: '5m 이하',
        1: '5m 초과 10m 이하',
        2: '10m 초과 15m 이하',
        3: '15m 초과 20m 이하',
        4: '20m 초과 25m 이하',
        5: '25m 초과',
    });

    /*  처음 props로 넘어온 trestles를 초기값 그대로 보관하고 있다가 취소 버튼을 눌렀을 때 원상 복귀 시키기 위해
        useRef를 사용하여 저장해 둔다. */
    // const initialTrestle = useRef(trestles || []);

    /* 벨트폭에 해당하는 Weight Table을 가져온다 */
    useEffect(() => {
        if (!standardWeight_Trestle || !beltWidth) return;
        const library = standardWeight_Trestle.find((item) => item.beltWidth === parseInt(beltWidth));
        if (!library) {
            alert('Check Belt Width!!');
            return;
        }
        weightLibrary.current = library;
    }, [beltWidth]);

    /* 기준 중량 가져오기 함수 */
    const getStandardWeight = useCallback((height) => {
        if (!weightLibrary.current) return;
        const heightCategory =
            height <= 5 ? 0 : height <= 10 ? 1 : height <= 15 ? 2 : height <= 20 ? 3 : height <= 25 ? 4 : 5;
        setHeightCategory(heightCategory);

        if (heightCategory === 5) {
            return height * 800 + 500;
        }

        const index = heightCategory;
        setStandardWeight(weightLibrary.current.standardWeight[index]);
        setColumnHeadWeight(
            heightCategory === 0 ? weightLibrary.current.columnHead[0] : weightLibrary.current.columnHead[1],
        );

        return;
    }, []);

    /* 기준 중량 가져오기 */
    useEffect(() => {
        if (!height) return;
        // const _standardWeight = getStandardWeight(Number(height));
        // const _unitWeight = _standardWeight * factor;
        getStandardWeight(Number(height));
    }, [getStandardWeight, height]);

    /* 단위 중량 및 중량 자동 계산 */
    useEffect(() => {
        // if (!height || !standardWeight || !columnHeadWeight || !factor || !qty) {
        //     return;
        // }
        const _unitWeight = Math.ceil(height * standardWeight * factor + columnHeadWeight);
        setUnitWeight(_unitWeight);
    }, [columnHeadWeight, factor, height, standardWeight]);

    useEffect(() => {
        const _weight = Math.ceil(unitWeight * qty);
        setWeight(_weight);
    }, [qty, unitWeight]);

    /* 마지막 Trestle ID 가져오기 함수 */
    const getLastId = useCallback(() => {
        if (!newTrestle.length) {
            return 0;
        }
        /* ChatGPT가 알려준 함수. 한줄로 정리가 되네....ㅋ */
        return Math.max(...newTrestle.map((trestle) => Number(trestle.id.substring(3))), 0);
    }, [newTrestle]);

    /* 입력 후 폼 초기화 함수 */
    const initializeForm = useCallback(() => {
        setId(`TR-${getLastId() * 1 + 1}`);
        // setTopWidth('');
        // setBottomWidth('');
        setHeightCategory('');
        setHeight('');
        // setArea('')
        setStandardWeight('');
        // setFactor('');
        setQty('');
        setUnitWeight('');
        setWeight('');
    }, [getLastId]);

    /* 전체 수량 계산 함수 */
    const getTotalQty = useCallback((items) => {
        const _totalQty = items.reduce((accumulator, currentValue) => {
            return accumulator + parseInt(currentValue.qty);
        }, 0);
        setTotalQty(_totalQty);
    }, []);

    /* 전체 중량 계산 함수 */
    const getTotalWeight = useCallback((items) => {
        const _totalWeight = items.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.weight;
        }, 0);
        setTotalWeight(_totalWeight);
    }, []);

    /* 추가 버튼을 누르면 newTrestle에 Trestle 추가 */
    const onAddTrestle = useCallback(() => {
        if (!qty || !unitWeight || !weight) {
            alert('Check input(s) before saving!!!');
            return;
        }
        const trestle = {
            id,
            heightCategory: categoryText.current[`${heightCategory}`],
            height,
            standardWeight,
            columnHeadWeight,
            factor,
            qty,
            unitWeight,
            weight,
        };
        setNewTrestle((prev) => [...prev, trestle]);
        setIsChanged(true);
    }, [columnHeadWeight, factor, height, heightCategory, id, qty, standardWeight, unitWeight, weight]);

    /* 삭제 버튼을 누르면 해당 Trestle 삭제 */
    const onDeleteTrestle = useCallback((id) => {
        setNewTrestle((prev) => prev.filter((trestle) => trestle.id !== id));
        setIsChanged(true);
    }, []);

    /* newTrestle에 변화가 생기면 리덕스에 변경사항 쓰기 */
    useEffect(() => {
        getTotalQty(newTrestle);
        getTotalWeight(newTrestle);
        initializeForm();
        onSaveStructure({
            key: 'trestle',
            value: newTrestle,
        });
        onChangeWeightSummary({
            key: 'trestle',
            value: {
                totalQty,
                totalWeight,
            },
        });
    }, [
        getTotalQty,
        getTotalWeight,
        initializeForm,
        newTrestle,
        onChangeWeightSummary,
        onSaveStructure,
        totalQty,
        totalWeight,
    ]);

    /* save 버튼을 누르면 리덕스에 변경사항 쓰기 */
    // const onSaveTrestle = useCallback(() => {
    //     onSaveStructure({
    //         key: 'trestle',
    //         value: newTrestle,
    //     });
    //     onChangeWeightSummary({
    //         key: 'trestle',
    //         value: {
    //             totalQty,
    //             totalWeight,
    //         },
    //     });
    // }, [newTrestle, onChangeWeightSummary, onSaveStructure, totalQty, totalWeight]);

    /* 변경 사항을 취소하면 newTrestle를 초기값으로 변경하고 리덕스에 초기값으로 쓰기 */
    // const onCancelChange = useCallback(() => {
    //     setNewTrestle(initialTrestle.current);
    //     onSaveStructure({
    //         key: 'trestle',
    //         value: initialTrestle.current,
    //     });
    //     onChangeWeightSummary({
    //         key: 'trestle',
    //         value: {},
    //     });
    //     setModal(false);
    // }, [onChangeWeightSummary, onSaveStructure]);

    /* Cancel Change 버튼을 눌렀을 때 */
    // const onClickCancel = useCallback(() => {
    //     // 저장된 적이 없다면 alert
    //     if (!isChanged) {
    //         alert('변경내용이 없습니다.');
    //         return;
    //     }
    //     setModal(true);
    // }, [isChanged]);

    return (
        <TrestleFormBlock>
            <Title>
                <h3 style={{ width: '400px', margin: '0' }}>Trestle</h3>
                <div style={{ width: '120px' }}>Q'ty: {totalQty} ea</div>
                <div style={{ width: '170px' }}>Weight: {totalWeight} kg</div>
                <div style={{ fontSize: '1.25rem', fontWeight: 'bold', display: 'flex', alignItems: 'flex-end' }}>
                    {!isShow ? (
                        <MdExpandMore color="orange" onClick={() => setIsShow(true)} />
                    ) : (
                        <MdExpandLess color="orange" onClick={() => setIsShow(false)} />
                    )}
                </div>
            </Title>
            {isShow && (
                <>
                    <table>
                        <thead>
                            <tr>
                                <th>ID.</th>
                                <th>
                                    Height <br /> (m)
                                </th>
                                <th>
                                    Height <br /> Category
                                </th>
                                <th>
                                    Standard W't <br />
                                    (kg/mH)
                                </th>
                                <th>
                                    Column Head <br /> W't (kg/ea)
                                </th>
                                <th>Factor</th>
                                <th>
                                    Unit W't <br />
                                    (kg/set)
                                </th>
                                <th>Q'ty</th>
                                <th>중량(kg)</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {newTrestle &&
                                newTrestle.map((trestle, index) => (
                                    <tr key={index}>
                                        <td>{trestle.id}</td>
                                        <td>{trestle.height}</td>
                                        <td>{trestle.heightCategory}</td>
                                        <td>{trestle.standardWeight}</td>
                                        <td>{trestle.columnHeadWeight}</td>
                                        <td>{trestle.factor}</td>
                                        <td>{trestle.unitWeight}</td>
                                        <td>{trestle.qty}</td>
                                        <td>{trestle.weight}</td>
                                        <td className="btn-delete" onClick={() => onDeleteTrestle(trestle.id)}>
                                            <MdRemoveCircleOutline />
                                        </td>
                                    </tr>
                                ))}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr>
                                <td></td>
                            </tr>{' '}
                            {/* 행 사이의 간격을 띄우기 위해 */}
                            <tr className="input-form">
                                {/* <td><StyledInput readOnly value={id} onChange={(e) => setId(e.target.value)} /></td> */}
                                <td className="id-column">{id}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={height}
                                        onChange={(e) => setHeight(e.target.value)}
                                    />
                                </td>
                                <td>{categoryText.current[`${heightCategory}`]}</td>
                                <td>
                                    <StyledInput readOnly value={standardWeight} />
                                </td>
                                <td>
                                    <StyledInput readOnly value={columnHeadWeight} />
                                </td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={factor}
                                        onChange={(e) => setFactor(e.target.value)}
                                    />
                                </td>
                                <td>{unitWeight}</td>
                                <td>
                                    <StyledInput
                                        placeholder="..."
                                        value={qty}
                                        onChange={(e) => setQty(e.target.value)}
                                    />
                                </td>
                                <td className="total-weight">{weight}</td>
                                <td className="btn-add" onClick={onAddTrestle}>
                                    <MdAdd />
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan={6}>Trestle Total</td>
                                <td></td>
                                <td>{totalQty}</td>
                                <td>{totalWeight}</td>
                            </tr>
                        </tfoot>
                    </table>
                    {/* <ActionButtons confirmText="Save" cancelText="Cancel Change" onConfirm={onSaveTrestle} onCancel={onClickCancel} /> */}
                    {/* <AskCancelModal visible={modal} onConfirm={onCancelChange} onCancel={() => setModal(false)} /> */}
                </>
            )}
        </TrestleFormBlock>
    );
};

/* =================   Styles   ================== */
const Title = styled.div`
    display: flex;
    align-items: flex-end;
    margin-bottom: 1rem;
    color: ${palette.cyan[6]};
`;

const TrestleFormBlock = styled.div`
    // max-width: 1280px;
    // margin: 0 auto;
    // margin: 0 2rem;
    .btn-delete {
        color: ${palette.cyan[6]};
        font-size: 1rem;
        cursor: pointer;
        padding: 0 1rem;
        padding-top: 0.3rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    .btn-add {
        color: ${palette.cyan[6]};
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0;
        padding-top: 0.4rem;
        &:hover {
            color: ${palette.cyan[4]};
        }
    }
    table {
        width: 100%;
        font-size: 0.9rem;
        border-collapse: collapse;
    }
    thead {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        color: ${palette.gray[7]};
    }
    tfoot {
        border-top: 1px solid ${palette.gray[4]};
        border-bottom: 1px solid ${palette.gray[4]};
        height: 2.5rem;
        font-weight: bold;
        color: ${palette.gray[7]};
    }
    th {
        padding: 0.5rem 0.25rem;
        text-align: center;
    }
    td {
        padding: 0.25rem 0.25rem;
        text-align: center;
    }
    .input-radio {
        display: flex;
        flex-direction: column;
        // margin: 0 1rem;
        align-items: flex-start;
        span {
            margin-left: 0.5rem;
        }
        // 추가함
        label + label {
            margin-top: 0.25rem;
        }
    }
    h3 {
        color: ${palette.cyan[6]};
    }
    .input-form {
        background-color: ${palette.gray[0]};
    }
`;

const StyledInput = styled.input`
    border: none;
    outline: none;
    padding: 0.25rem 0.5rem;
    width: 50px;
    text-align: center;
    background: transparent;
    &:hover {
        background: ${palette.gray[3]};
    }
`;

export default TrestleForm;
